import React, { useEffect } from "react";
import "./VideoModal.css";

function VideoModal({ onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const handleOverlayClick = (event) => {
    if (event.target.classList.contains("video-modal-overlay")) {
      onClose();
    }
  };

  return (
    <div className="video-modal-overlay" onClick={handleOverlayClick}>
      <div className="video-modal">
        <div className="video-modal-frame">
          <iframe
            src="https://www.youtube.com/embed/u31qwQUeGuM?autoplay=1&rel=0"
            title="BeszÉLJ videó"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />

          <button
            className="video-modal-close"
            onClick={onClose}
            aria-label="Videó bezárása"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}

export default VideoModal;